<template>
    <app-content-admin>
        <template slot="header">View AdZone Details</template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="secondary"
                to="/adzone"
            >
                Back
            </v-btn>
        </template>
        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Name')"
                                        v-model="form.zone_name"
                                        :rules="[rules.required('Name')]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Description')"
                                        v-model="form.zone_description"
                                        :rules="[rules.required('Description')]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Rotate Time(Seconds)')"
                                        v-model="form.zone_rotate_time"
                                        :data-label="$t('Rotate Time(Seconds)')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="handleZoneRotateTimeInput"
                                        :rules="[
                                            rules.required(
                                                'Rotate Time(Seconds)'
                                            ),
                                        ]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Active')"
                                        v-model="form.zone_active"
                                        :data-label="$t('Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="updateAdzone"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";
import router from "../../router";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                zone_id: null,
                zone_name: null,
                zone_description: null,
                zone_rotate_time: 0,
                zone_active: 0,
                token: null,
            },
            showpass: false,
        };
    },

    components: { ActiveLabel },

    created() {
        this.form.zone_id = this.$route.params.id;
        this.getAdzone();
    },

    methods: {
        //Update Specific AdZone
        async updateAdzone() {
            let loader = this.$loading.show();
            try {
                let res = await axios.post(
                    `/api/auth/update_ad_zone`,
                    this.form
                );
                if (res.status == 200) {
                    this.$toastr.s("Adzone update successfully");
                    router.push("/adzone");
                }
            } catch (err) {
                if (err.response.status === 400) {
                    // Validation errors returned by the server
                   // this.$toastr.e("Please input all required data");
                } else {
                   // this.$toastr.e("An error occurred while creating the AdZone.");
                    console.log("Error create adZone", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Read specific AdZone
        async getAdzone() {
            let loader = this.$loading.show();
            try {
                let res = await axios.get(`/api/auth/get_ad_zone`, {
                    params: { zone_id: this.form.zone_id },
                });

                if (res.status == 200) {
                    // console.log("AdZone Data:",res.data.adZone);
                    this.form.zone_name = res.data.adZone.zone_name;
                    this.form.zone_description =res.data.adZone.zone_description;
                    this.form.zone_rotate_time =res.data.adZone.zone_rotate_time;
                    this.form.zone_active = res.data.adZone.zone_active;
                }
            } catch (err) {
               // this.$toastr.e(err.response.data.message);
                console.log("Get specific adzone data fail");
            } finally {
                loader.hide();
            }
        },

        //Prevent zero or neg typing for rotate_time
        handleZoneRotateTimeInput() {
            // Ensure that the value is not negative
            if (this.form.zone_rotate_time < 0) {
                this.form.zone_rotate_time = 0;
            }

            // Remove leading zeros
            if (
                this.form.zone_rotate_time.length > 1 &&
                this.form.zone_rotate_time[0] === "0"
            ) {
                this.form.zone_rotate_time =
                    this.form.zone_rotate_time.slice(1);
            }
        },
    },
};
</script>
<style>
.theme--light.v-text-field--outlined:not(
        .v-input--is-focused
    ).v-input--is-disabled
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgba(0, 0, 0, 0.36);
}

.theme--light.v-label--is-disabled {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-select .v-select__selection--disabled {
    color: rgba(0, 0, 0, 0.6);
}
</style>
